import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ChartComponent } from "ng-apexcharts";
import { AppRooute } from 'src/app/core/common/app-route.model';
import { RouteConstant } from 'src/app/core/common/route-constant';
import { AuthService } from 'src/app/core/services/auth/auth.service';

import {
  ApexChart,
  ApexLegend,
  ApexNonAxisChartSeries,
  ApexResponsive
} from "ng-apexcharts";
import { DesaparecidoService } from 'src/app/core/services/caso/desaparecido.service';
import { DashboardVo } from 'src/app/shared/models/dashboard/dashboard.vo';

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  legend: ApexLegend;
  responsive: ApexResponsive[];
  labels: any;
};
@Component({
  selector: 'vex-dashboard-user',
  templateUrl: './dashboard-user.component.html',
  styleUrls: ['./dashboard-user.component.scss']
})
export class DashboardUserComponent implements OnInit {

  desaparecidoService = inject(DesaparecidoService);
  authService = inject(AuthService);
  role: any;

  @ViewChild("chartDesaparecidoNoEncontrado") chartDesaparecidoNoEncontrado: ChartComponent;
  public chartDesaparecidoNoEncontradoOptions: Partial<ChartOptions>;

  @ViewChild("chartDesaparecidoEncontrado") chartDesaparecidoEncontrado: ChartComponent;
  public chartDesaparecidoEncontradoOptions: Partial<ChartOptions>;

  @ViewChild("chartEncontradoServicio") chartEncontradoServicio: ChartComponent;
  public chartEncontradoServicioOptions: Partial<ChartOptions>;

  @ViewChild("chartEncontradoSinServicio") chartEncontradoSinServicio: ChartComponent;
  public chartEncontradoSinServicioOptions: Partial<ChartOptions>;

  @ViewChild("chartServicioSalud") chartServicioSalud: ChartComponent;
  public chartServicioSaludOptions: Partial<ChartOptions>;

  @ViewChild("chartServicioDna") chartServicioDna: ChartComponent;
  public chartServicioDnaOptions: Partial<ChartOptions>;

  @ViewChild("chartServicioAmbos") chartServicioAmbos: ChartComponent;
  public chartServicioAmbosOptions: Partial<ChartOptions>;

  dashboardVo: DashboardVo;
  crumbs: AppRooute[] = [RouteConstant.ROUTE_CASE_MISSING];

  constructor() {

  }

  ngOnInit(): void {

    if(this.authService.isAuthenticated())
      this.role = this.authService.user.roles[0];

    this.desaparecidoService.getDashboard().subscribe(respose => {
      this.dashboardVo = respose.data;

      this.chartDesaparecidoNoEncontradoOptions = {
        series: [Number(this.dashboardVo.desaparecidos.noEncontradas.adulto), Number(this.dashboardVo.desaparecidos.noEncontradas.nna)],
        chart: {
          width: "100%",
          type: "pie"
        },
        labels: ["Adultos", "NNAs"],
        legend: {
          show: true,
          position: 'left'
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      };
      this.chartDesaparecidoEncontradoOptions = {
        series: [Number(this.dashboardVo.desaparecidos.encontradas.adulto), Number(this.dashboardVo.desaparecidos.encontradas.nna)],
        chart: {
          width: "100%",
          type: "pie"
        },
        labels: ["Adultos", "NNAs"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      };


      this.chartEncontradoServicioOptions = {
        series: [Number(this.dashboardVo.encontradas.servicios.adulto), Number(this.dashboardVo.encontradas.servicios.nna)],
        chart: {
          width: "100%",
          type: "pie"
        },
        labels: ["Adultos", "NNAs"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      };
      this.chartEncontradoSinServicioOptions = {
        series: [Number(this.dashboardVo.encontradas.sinServicios.adulto), Number(this.dashboardVo.encontradas.sinServicios.nna)],
        chart: {
          width: "100%",
          type: "pie"
        },
        labels: ["Adultos", "NNAs"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      };


      this.chartServicioSaludOptions = {
        series: [Number(this.dashboardVo.servicios.salud.adulto), Number(this.dashboardVo.servicios.salud.nna)],
        chart: {
          width: "100%",
          type: "pie"
        },
        labels: ["Adultos", "NNAs"],
        responsive: [
          {
            breakpoint: 800,
            options: {
              chart: {
                width: 180
              },
              legend: {
                //show: false,
                position: "bottom"
              }
            }
          }
        ]
      };
      this.chartServicioDnaOptions = {
        series: [Number(this.dashboardVo.servicios.dna.adulto), Number(this.dashboardVo.servicios.dna.nna)],
        chart: {
          width: "100%",
          type: "pie"
        },
        labels: ["Adultos", "NNAs"],
        responsive: [
          {
            breakpoint: 800,
            options: {
              chart: {
                width: 180
              },
              legend: {
                //show: false,
                position: "bottom"
              }
            }
          }
        ]
      };
      this.chartServicioAmbosOptions = {
        series: [Number(this.dashboardVo.servicios.ambos.adulto), Number(this.dashboardVo.servicios.ambos.nna)],
        chart: {
          width: "100%",
          type: "pie"
        },
        labels: ["Adultos", "NNAs"],
        responsive: [
          {
            breakpoint: 800,
            options: {
              chart: {
                width: 180
              },
              legend: {
                //show: false,
                position: "bottom"
              }
            }
          }
        ]
      };
    });

  }
}
